export default __webpack_public_path__ + "static/media/wrong.9e6ce1e8.png";